import { SubscriptionTier, SubscriptionType } from "@WahooFitness/cloud-client-types";

export type NormalizedPendingChange = {
  id?: number;
  // "iap" changes carry no real cloud amount (RevenueCat product-change webhooks have no
  // pricing) — price them from the store offering.
  source: "card" | "iap";
  plan_code?: string | null;
  subscription_tier_id?: SubscriptionTier;
  currency?: string | null;
  subscription_amount_cents?: number;
  total_amount_cents?: number;
  interval?: string;
  current_period_start?: string | null;
  plan_type?: string;
};

// Merges the mutually exclusive subscription_pending_change (card/web) and
// subscription_pending_iap_change (Apple/Google) sources so call sites don't branch on processor.
export function getPendingSubscriptionChange(
  userSubscription?: SubscriptionType
): NormalizedPendingChange | undefined {
  const card = userSubscription?.subscription_pending_change;
  const iap = userSubscription?.subscription_pending_iap_change;
  const source = card ?? iap;
  if (!source) return undefined;

  return {
    id: source.id,
    source: card ? "card" : "iap",
    plan_code: source.plan_code,
    subscription_tier_id: card
      ? (card as { subscription_tier_id?: SubscriptionTier }).subscription_tier_id
      : iap?.subscription_tier_id,
    currency: source.currency,
    subscription_amount_cents: source.subscription_amount_cents,
    total_amount_cents: card?.total_amount_cents,
    interval: card?.interval,
    // iap payloads have no current_period_start; effective_at is the closest equivalent.
    current_period_start: card?.current_period_start ?? iap?.effective_at,
    plan_type: card?.plan_type,
  };
}
